import { createSelector } from 'reselect';

import { RootState } from '@setup/typedefs';

const uiSelector = (state: RootState) => state.ui;

export const getTheme = createSelector([uiSelector], (result) => {
  return result.theme;
});
